export default __webpack_public_path__ + "static/media/whatsApp.fbe2da62.svg";